import { HeroReportImage } from '../hero-report-image/hero-report-image.model';
import { EodIncidentReport } from '../incident-report/eod-incident-report.model';
import {Account} from "../account/account.model";


export interface HeroReport {
  id: string;

  account: Account;

  eodIncidentReport: EodIncidentReport;

  heroReportImages: HeroReportImage[];

  /** UXO (the default) or SRE. Set when the report is created and never changed. */
  reportType?: 'UXO' | 'SRE';

  /** The report's stable number, created by the API (the first is 1001). Reports show it as HR-<number>. */
  reportNumber?: number;

  latitude: number;
  longitude: number;

  possibleIdentification: string[];

  status: string;
  firstNoticedDate: Date | null;
  previousFindings: boolean | null;
  wasItemMoved: boolean | null;
  pocName: string | null;
  pocPhone: string | null;
  liquidOrCrystallization: boolean | null;
  deadAnimalsOrFoliage: boolean | null;
  casualties: string;
  evacuationPerimeterM: number | null;
  infrastructurePresent: boolean | null;
  radioTransmitters: boolean | null;
  powerLines: boolean | null;
  fuelTanks: boolean | null;
  buildingsInFragZone: boolean | null;
  additionalHazards: string;
  accessibility: string;

  // SRE report details
  mgrs?: string | null;
  depthCm?: number | null;
  parcelNumber?: string | null;
  laneNumber?: string | null;
  distance?: number | null;
  reporterTitle?: string | null;
  additionalComments?: string | null;

  createdDate: Date;
  updatedDate: Date | null;
  endDate: Date | null;
}

export function getHeroName(heroReport: HeroReport): string {
  let heroName = "Unknown"

  let nameSegments: string[] = []
  if (heroReport?.account?.firstName) {
    nameSegments.push(heroReport?.account?.firstName)
  }
  if (heroReport?.account?.lastName) {
    nameSegments.push(heroReport?.account?.lastName)
  }

  if (nameSegments.length > 0) {
    heroName = nameSegments.join(" ")
  }

  return heroName
}
